


export const FEATURE_CATEGORIES = {
	enabledStores: [ 
		'pixelatoms', 
	],
};